export default __webpack_public_path__ + "3fa8f441cbaf9b02c32f79804822e445.png";